import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "@/api/client";
import type { HolandaOverview, HolandaTicket } from "@/api/types";

// El monitor refresca channel_state cada 5 min; sondeamos cada 30s para que la
// pantalla de atención se sienta viva sin martillar la API.
const REFETCH_MS = 30_000;

export function useHolandaOverview() {
  return useQuery({
    queryKey: ["holanda-overview"],
    queryFn: ({ signal }) => api<HolandaOverview>("/api/v1/holanda/overview", { signal }),
    refetchInterval: REFETCH_MS,
    placeholderData: (prev) => prev,
  });
}

interface TicketTarget {
  device_gid: string;
  channel_num: number;
}
interface NoteVars extends TicketTarget {
  text: string;
}
interface ResolveVars extends TicketTarget {
  disposition: string;
  note?: string;
}

// Toda acción de ticket reescribe holanda_ticket y refresca el tablero.
function useTicketAction<V extends TicketTarget>(path: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: V) => api<HolandaTicket>(path, { method: "POST", body: vars }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["holanda-overview"] }),
  });
}

export const useAttendTicket = () => useTicketAction<TicketTarget>("/api/v1/holanda/tickets/attend");
export const useNoteTicket = () => useTicketAction<NoteVars>("/api/v1/holanda/tickets/note");
export const useResolveTicket = () => useTicketAction<ResolveVars>("/api/v1/holanda/tickets/resolve");
